import React, {useEffect, useState} from 'react';

import "./style.scss";
import SlaChanger from "./SlaChanger/SlaChanger";


export default function SlaQuickChanger({
                                            business,
                                            isBusinessChanging,
                                            isDistributionAreasChanging,
                                            isAreaSlaEnabled,
                                            distributionAreas,
                                            editDefaultSla,
                                            editDistributionArea
                                        }) {
    const [sortedDistributionAreas, setSortedDistributionAreas] = useState([]);

    useEffect(() => {
        if (distributionAreas) {
            const tmpDistAreas = [...distributionAreas];

            tmpDistAreas.sort((a, b) => a.level - b.level);

            setSortedDistributionAreas(tmpDistAreas);
        }
    }, [distributionAreas]);


    function handleDefaultSlaPlusClick() {
        editDefaultSla(business.id, business.sla + 5);
    }

    function handleDefaultSlaMinusClick() {
        if (business.sla - 5 > 0)
            editDefaultSla(business.id, business.sla - 5);
    }

    function handleDistAreaSlaPlusClick(distributionArea) {
        editDistributionArea({
            bid: distributionArea.bid,
            id: distributionArea.id, sla: distributionArea.sla + 5
        });
    }

    function handleDistAreaSlaMinusClick(distributionArea) {
        if (distributionArea.sla - 5 > 0)
            editDistributionArea({
                bid: distributionArea.bid,
                id: distributionArea.id, sla: distributionArea.sla - 5
            });
    }

    if (!business)
        return null;

    const defaultSlaName = isAreaSlaEnabled && sortedDistributionAreas && sortedDistributionAreas.length > 0 ?
        "ברירת מחדל" : "זמן התחייבות";

    return (
        <div className="sla-quick-changer">
            <div className="sla-changer-container">
                <SlaChanger name={defaultSlaName} sla={business.sla}
                            onPlus={handleDefaultSlaPlusClick} onMinus={handleDefaultSlaMinusClick}
                            disabled={isBusinessChanging}/>
            </div>
            {
                isAreaSlaEnabled && sortedDistributionAreas ?
                    sortedDistributionAreas.map((distributionArea, index) => (
                        <div key={distributionArea.id}
                             className="sla-changer-container">
                            <SlaChanger name={distributionArea.name || `אזור ${index + 1}`} sla={distributionArea.sla}
                                        onPlus={() => handleDistAreaSlaPlusClick(distributionArea)}
                                        onMinus={() => handleDistAreaSlaMinusClick(distributionArea)}
                                        disabled={isDistributionAreasChanging}/>
                        </div>
                    ))
                    :
                    null
            }
        </div>
    );
}
